import StickyBottomNavBar from './StickyBottomNavBar';

export default StickyBottomNavBar;